import { defineMessages } from 'react-intl';

/* eslint-disable max-len */

export default defineMessages({
  loginButton: {
    id: 'login.google.button',
    description: 'Login button for Google login',
    defaultMessage: 'Kirjaudu Googlella',
  },
});
